<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parksetmeal_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/setmeal/parksetmeal';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '40%',
        labelWidth: 130,
        column: [
          {
            label: '停车场',
            prop: 'parkingLotId',
            type: 'select',
            dicUrl: '/api/parking/lot/selections',
            editDisabled: true,
            search: true,
            props: {
              label: 'label',
              value: 'value',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐名称',
            prop: 'setmealName',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入套餐名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐编号',
            prop: 'setmealNo',
            editDisabled: true,
            maxlength: 16,
            rules: [
              {
                required: true,
                message: '请输入套餐编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐类型',
            prop: 'setmealType',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=setmeal_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请选择套餐类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '套餐价格(元)',
            prop: 'setmealPrice',
            rules: [
              {
                required: true,
                message: '请输入套餐价格，单位：元',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.money,
                message: '金额格式不对',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 128,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    });
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parksetmeal_add, true),
        viewBtn: this.vaildData(this.permission.parksetmeal_view, false),
        delBtn: this.vaildData(this.permission.parksetmeal_delete, true),
        editBtn: this.vaildData(this.permission.parksetmeal_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
